export interface SnackbarMessage {
  message: string;
  key: number;
  title: string;
  type?: SnackBarType;
  variant?: SnackBarVariant;
  timeout?: number;
}

export enum SnackBarType {
  ERROR = "error",
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
}

export enum SnackBarVariant {
  FILLED = "filled",
  OUTLINED = "outlined",
}

export interface SnackBarState {
  open: boolean;
  snackPack: readonly SnackbarMessage[];
  messageInfo?: SnackbarMessage;
  title?: string;
  type?: SnackBarType;
  variant?: SnackBarVariant;
  timeout?: number;
}

export interface TriggerSnackBar {
  message: string;
  title?: string;
  type?: SnackBarType;
  variant?: SnackBarVariant;
  timeout?: number;
}
